import { render, staticRenderFns } from "./CollectionHistory.vue?vue&type=template&id=1c7b6266"
import script from "./CollectionHistory.vue?vue&type=script&lang=js"
export * from "./CollectionHistory.vue?vue&type=script&lang=js"
import style0 from "./CollectionHistory.vue?vue&type=style&index=0&id=1c7b6266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports